import { render, staticRenderFns } from "./sigmm-carer-awards.vue?vue&type=template&id=377b3bc6&scoped=true&"
import script from "./sigmm-carer-awards.vue?vue&type=script&lang=js&"
export * from "./sigmm-carer-awards.vue?vue&type=script&lang=js&"
import style0 from "./sigmm-carer-awards.vue?vue&type=style&index=0&id=377b3bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b3bc6",
  null
  
)

export default component.exports